
const styles = {
  body: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    backgroundColor: '#f8fafc',
    margin: 0,
    padding: 0,
    lineHeight: 1.6,
    color: '#334155'
  },
  
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '20px',
    minHeight: '100vh'
  },
  
  header: {
    background: 'linear-gradient(135deg, #0f5132 0%, #198754 100%)',
    color: 'white',
    padding: '2rem',
    borderRadius: '16px',
    marginBottom: '24px',
    boxShadow: '0 8px 32px rgba(15, 81, 50, 0.2)',
    position: 'relative',
    overflow: 'hidden'
  },
  
  headerOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '200px',
    height: '200px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '50%',
    transform: 'translate(50px, -50px)'
  },
  
  headerContent: {
    position: 'relative',
    zIndex: 1
  },
  
  headerTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    margin: '0 0 0.5rem 0',
    background: 'linear-gradient(45deg, #fff, #e2f4e8)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },
  
  headerSubtitle: {
    fontSize: '1.2rem',
    opacity: 0.9,
    margin: 0,
    fontWeight: '400'
  },
  
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'white',
    padding: '1rem 1.5rem',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    marginBottom: '24px',
    border: '1px solid #e2e8f0'
  },
  
  navButtons: {
    display: 'flex',
    gap: '8px'
  },
  
  navButton: {
    padding: '12px 20px',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    background: 'transparent',
    color: '#64748b',
    position: 'relative',
    overflow: 'hidden'
  },
  
  navButtonActive: {
    background: 'linear-gradient(135deg, #0f5132, #198754)',
    color: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(15, 81, 50, 0.3)'
  },
  
  navButtonHover: {
    background: '#f1f5f9',
    color: '#0f5132',
    transform: 'translateY(-1px)'
  },
  
  logoutButton: {
    padding: '12px 20px',
    background: 'linear-gradient(135deg, #dc2626, #ef4444)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(220, 38, 38, 0.2)'
  },
  
  card: {
    background: 'white',
    padding: '2rem',
    borderRadius: '20px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    marginBottom: '24px',
    border: '1px solid #e2e8f0',
    position: 'relative'
  },
  
  cardTitle: {
    fontSize: '1.875rem',
    fontWeight: '700',
    color: '#0f172a',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  
  primaryButton: {
    padding: '14px 28px',
    background: 'linear-gradient(135deg, #0f5132, #198754)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(15, 81, 50, 0.2)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px'
  },
  
  secondaryButton: {
    padding: '10px 16px',
    background: '#f1f5f9',
    color: '#475569',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  },
  
  dangerButton: {
    padding: '10px 16px',
    background: 'linear-gradient(135deg, #dc2626, #ef4444)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  },
  
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    marginTop: '20px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  
  tableHeader: {
    background: 'linear-gradient(135deg, #0f5132, #198754)',
    color: 'white'
  },
  
  tableHeaderCell: {
    padding: '16px 20px',
    textAlign: 'left',
    fontSize: '0.9rem',
    fontWeight: '600',
    letterSpacing: '0.05em'
  },
  
  tableCell: {
    padding: '16px 20px',
    borderBottom: '1px solid #f1f5f9',
    fontSize: '0.95rem',
    verticalAlign: 'middle'
  },
  
  tableRow: {
    background: 'white',
    transition: 'background-color 0.2s ease'
  },
  
  tableRowHover: {
    background: '#f8fafc'
  },
  
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
    marginBottom: '2rem'
  },
  
  statCard: {
    background: 'white',
    padding: '2rem',
    borderRadius: '20px',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e2e8f0',
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.2s ease'
  },
  
  statCardHover: {
    transform: 'translateY(-2px)'
  },
  
  statNumber: {
    fontSize: '3rem',
    fontWeight: '800',
    background: 'linear-gradient(135deg, #0f5132, #198754)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '0.5rem'
  },
  
  statLabel: {
    fontSize: '1.1rem',
    color: '#64748b',
    fontWeight: '500'
  },
  
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  
  modalContent: {
    background: 'white',
    borderRadius: '24px',
    padding: '0',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    position: 'relative'
  },
  
  modalHeader: {
    padding: '2rem 2rem 1rem 2rem',
    borderBottom: '1px solid #f1f5f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  
  modalTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#0f172a',
    margin: 0
  },
  
  modalBody: {
    padding: '2rem',
    maxHeight: '60vh',
    overflowY: 'auto'
  },
  
  formGroup: {
    marginBottom: '1.5rem'
  },
  
  formLabel: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '0.95rem',
    fontWeight: '600',
    color: '#374151'
  },
  
  formInput: {
    width: '100%',
    padding: '12px 16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    fontSize: '1rem',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box'
  },
  
  formInputFocus: {
    borderColor: '#0f5132',
    outline: 'none',
    boxShadow: '0 0 0 3px rgba(15, 81, 50, 0.1)'
  },
  
  formTextarea: {
    width: '100%',
    padding: '12px 16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    fontSize: '1rem',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
    minHeight: '120px',
    resize: 'vertical'
  },
  
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  
  badgeSuccess: {
    background: '#dcfce7',
    color: '#166534'
  },
  
  badgeWarning: {
    background: '#fef3c7',
    color: '#92400e'
  },
  
  badgeInfo: {
    background: '#dbeafe',
    color: '#1e40af'
  },
  
  loadingSpinner: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    border: '2px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '2px solid #0f5132',
    animation: 'spin 1s linear infinite'
  },
  
  emptyState: {
    textAlign: 'center',
    padding: '3rem',
    color: '#64748b'
  },
  
  emptyStateIcon: {
    fontSize: '3rem',
    marginBottom: '1rem',
    opacity: 0.3
  },
  
  loginCard: {
    maxWidth: '400px',
    margin: '10vh auto',
    background: 'white',
    borderRadius: '24px',
    padding: '2rem',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e2e8f0'
  }
};
export default styles;